module.exports = __webpack_public_path__ + "static/media/12-2.70ee0504.mp3";